import { OnInit, OnDestroy } from '@angular/core';
import { TokenManager } from '../Globals';
import { LoginService } from '../services/login.service';
import { NgProgress } from '@ngx-progressbar/core';
import { Globals } from '../objects/Globals';
import { Router } from '@angular/router';
import { MainLoadingService } from '../services/main-loading.service';
import { WorkflowReturnService } from '../services/workflow-return.service';
var LogoComponent = /** @class */ (function () {
    function LogoComponent(tokenManager, loginService, progress, globals, router, mainLoadingService, workflowReturnService) {
        var _this = this;
        this.tokenManager = tokenManager;
        this.loginService = loginService;
        this.progress = progress;
        this.globals = globals;
        this.router = router;
        this.mainLoadingService = mainLoadingService;
        this.workflowReturnService = workflowReturnService;
        this.startPage = false;
        this.subRouter = router.events.subscribe(function (val) {
            if (router.url.indexOf("/khamis-start") > -1) {
                _this.startPage = true;
            }
            else {
                _this.startPage = false;
            }
        });
    }
    LogoComponent.prototype.ngOnInit = function () {
        this.progressRef = this.progress.ref('progressBar');
    };
    LogoComponent.prototype.goToHome = function () {
        var _this = this;
        if (!this.startPage) {
            this.tokenManager.store("BRNCurrentMenu", "Home");
            this.mainLoadingService.setProgressBar(true);
            this.loginService.getHomePage().subscribe(function (result) {
                var command = JSON.parse(result);
                _this.workflowReturnService.handleWorkflowReturn(command, true, true);
                _this.mainLoadingService.setProgressBar(false);
            });
        }
    };
    LogoComponent.prototype.ngOnDestroy = function () {
        if (this.subRouter)
            this.subRouter.unsubscribe();
    };
    return LogoComponent;
}());
export { LogoComponent };
